import TheDiagram from "./TheDiagram";
import ExitLinks from "./ExitLinks";
import { useSearchParams } from "react-router-dom";
import '../../styles/station-diagram.css';

export default function StationMainDiagram({data}) {
    const [searchParams] = useSearchParams();
    const station = searchParams.get("station");
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const yyyy = yesterday.getFullYear();
    const mm = String(yesterday.getMonth() + 1).padStart(2, '0');
    const dd = String(yesterday.getDate()).padStart(2, '0');
    const formattedDate = `${yyyy}-${mm}-${dd}`;
    return (
        <div className="station-main-diagram">
            <TheDiagram data={data}/>
            <div className="exit-links">
                {/* <ExitLinks to={`/raport-detail?station=${station}`} title="Raport szczegółowy"/> */}
                <ExitLinks to={`/raports?station=${station}&day=${formattedDate}`} title="Poprzedni dzień"/>                
                {/* <ExitLinks to={`/prices?station=${station}`} title="Obecne ceny"/> */}
                {/* <ExitLinks to={`/forecasts?station=${station}`} title="Prognozy"/> */}
            </div>
        </div>
    )
}